export const courseFlow = {
  title: 'コースの流れ',
  subtitle: 'EachTeachの学習プロセスをご紹介します',
  
  // Hero
  heroTitle: 'コースの流れ',
  heroSubtitle: '基礎となるA〜Cレベルのコースから、実践重視のアドバンスレッスンまで',
  
  // Level Check Notice
  levelCheckTitle: 'レベルチェックテストについて',
  levelCheckDescription1: 'すべての受講生は、レベルチェックテストを受けていただきます。',
  levelCheckDescription2: 'テスト結果に基づいて、現在の言語レベル（A、B1、B2、C）を判定し、最適なレベルからスタートできるようサポートします。',
  levelCheckDescription3: '初心者の方はレベルAから、既に基礎がある方はB1やB2から始めることができ、',
  levelCheckDescription4: '無駄な時間をかけずに効率的に学習を進められます。',
  levelCheckButton: 'レベルチェックを受ける',
  registerButton: '先に登録する',
  
  // Foundation Courses
  foundationTitle: '基礎コース（A〜C）',
  
  // Level A
  levelATitle: '完全初心者',
  levelALessons: '18レッスン + Aレベル単語ノート',
  levelADescription: '完全初心者向け。基本的な語彙と文法の基礎を学びます。',
  
  // Extra Lessons
  extraLessonAB1: 'エクストラレッスン（A→B1）',
  extraLessonAB1Description: '1回のテスト + 2回の補強レッスン = 3レッスン分の料金',
  
  // Level B1
  levelB1Title: '中級基礎',
  levelB1Lessons: '14レッスン',
  levelB1Description: '日常会話の流暢さを構築し、語彙を拡大します。',
  
  extraLessonB1B2: 'エクストラレッスン（B1→B2）',
  extraLessonB1B2Description: '1回のテスト + 2回の補強レッスン = 3レッスン分の料金',
  
  // Level B2
  levelB2Title: 'プロフェッショナルレベル',
  levelB2Lessons: '10レッスン',
  levelB2Description: '接客業務が可能なレベル。ニュアンスや慣用句を磨きます。',
  
  extraLessonB2C: 'エクストラレッスン（B2→C）',
  extraLessonB2CDescription: '1回のテスト + 2回の補強レッスン = 3レッスン分の料金',
  
  // Level C
  levelCTitle: 'ネイティブに近い流暢さ',
  levelCLessons: '10レッスン',
  levelCDescription: 'ネイティブに近い流暢さ。文化的なニュアンスと高度な表現をマスターします。',
  
  // Additional Lessons
  additionalTitle: 'アドバンスレッスン',
  additionalBadge: 'A〜Cレベル修了後',
  additionalSubtitle: '8つの専門分野別コース。',
  additionalPricing: '料金は通常レッスンの1.2倍です。',
  
  // Courses
  course1Title: '日常生活とカジュアルコミュニケーション',
  course1Description: '日常会話、雑談、スラング、慣用句など',
  
  course2Title: '接客・ホスピタリティコミュニケーション',
  course2Description: '注文対応、説明、おすすめ、クレーム対応など',
  
  course3Title: 'キッチン・調理コミュニケーション',
  course3Description: '指示、食材・調理用語、安全確認など',
  
  course4Title: '販売・レジコミュニケーション',
  course4Description: '商品説明、在庫確認、支払い、返品・交換など',
  
  course5Title: 'ホテル・フロント業務',
  course5Description: 'チェックイン・アウト、施設案内、電話対応など',
  
  course6Title: '清掃・バックヤード業務',
  course6Description: '指示理解、確認表現、チェックリスト、安全関連など',
  
  course7Title: 'リゾート・季節労働',
  course7Description: '観光地や短期雇用での多国籍環境でのコミュニケーション',
  
  course8Title: '職場・高度なコミュニケーション',
  course8Description: 'メール、報告、調整、依頼、トラブル共有など',
  
  lessonsLabel: 'レッスン',
  registerNow: '今すぐ登録'
};
